let dialog = null

const getDialog = () => {
  if (dialog) return dialog

  dialog = document.createElement("dialog")
  dialog.className = "lightbox"
  dialog.innerHTML = `
    <button class="lightbox__close" aria-label="Close">&times;</button>
    <img class="lightbox__img" src="" alt="">
  `

  const close = () => dialog.close()

  dialog.querySelector(".lightbox__close").addEventListener("click", close)

  // Close on backdrop click
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) close()
  })

  // Clear image on any close (button, backdrop, ESC)
  dialog.addEventListener("close", () => {
    dialog.querySelector(".lightbox__img").src = ""
  })

  document.body.appendChild(dialog)
  return dialog
}

export function initLightbox() {
  document.querySelectorAll("[data-lightbox]").forEach((figure) => {
    figure.style.cursor = "zoom-in"
    const img = figure.querySelector("img")

    figure.addEventListener("click", () => {
      const dlg = getDialog()
      const lightboxImg = dlg.querySelector(".lightbox__img")
      lightboxImg.src = figure.dataset.lightbox
      lightboxImg.alt = img ? img.alt : ""
      dlg.showModal()
    })
  })
}
